import script from "./InternalConfigurations.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalConfigurations.vue?vue&type=script&setup=true&lang=js"

import "./InternalConfigurations.vue?vue&type=style&index=0&id=36a8cc84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36a8cc84"]])

export default __exports__